import type { TPostDynamicContentProps } from './DynamicContent.types';

const DynamicContent = ({ children }: TPostDynamicContentProps) => {
  return children;
};

export { DynamicContent };
